import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import { showToast } from "../helpers/toast"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "actionBar", "count", "reasonSelect"]

  toggleAll(event) {
    this.checkboxTargets.forEach(cb => cb.checked = event.target.checked)
    this.updateSelection()
  }

  updateSelection() {
    const selected = this.checkboxTargets.filter(cb => cb.checked)
    this.countTarget.textContent = selected.length
    this.actionBarTarget.classList.toggle("hidden", selected.length === 0)
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.indeterminate = selected.length > 0 && selected.length < this.checkboxTargets.length
      this.selectAllTarget.checked = selected.length > 0 && selected.length === this.checkboxTargets.length
    }
  }

  clearSelection() {
    this.checkboxTargets.forEach(cb => cb.checked = false)
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = false
    }
    this.actionBarTarget.classList.add("hidden")
  }

  async bulkDisqualify(event) {
    const ids = this.selectedIds
    if (ids.length === 0) return

    const reason = this.reasonSelectTarget.value
    if (!reason) {
      showToast("Veuillez sélectionner une raison de disqualification", "error")
      return
    }

    const url = event.currentTarget.dataset.phoningBulkDisqualifyUrl
    const token = document.querySelector("meta[name='csrf-token']")?.content

    const response = await fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        "Accept": "text/vnd.turbo-stream.html"
      },
      body: JSON.stringify({ contact_ids: ids, reason: reason })
    })

    if (response.ok) {
      const html = await response.text()
      Turbo.renderStreamMessage(html)
      this.clearSelection()
      this.reasonSelectTarget.value = ""
      showToast(`${ids.length} contact(s) disqualifié(s)`)
    } else {
      showToast("Erreur lors de la disqualification", "error")
    }
  }

  get selectedIds() {
    return this.checkboxTargets.filter(cb => cb.checked).map(cb => cb.value)
  }
}
